import { gql } from "apollo-boost";


export const DELETE_OFFERPRICE_GROUP = gql`
mutation DeleteOfferPriceGroup($where: OfferPriceGroupWhereInputOne!) {
  deleteOfferPriceGroup(where: $where) {
    id
  }
}
`

export const UPDATE_OFFERPRICE_ISSALE = gql`
mutation UpdateOfferPriceGroup($where: OfferPriceGroupWhereInputOne!, $data: OfferPriceGroupInput) {
  updateOfferPriceGroup(where: $where, data: $data) {
    id
  }
}
`


export const UPDATE_OFFERPRICE_GROUP = gql`
mutation UpdateOfferPriceGroup($where: OfferPriceGroupWhereInputOne!, $data: OfferPriceGroupInput) {
  updateOfferPriceGroup(where: $where, data: $data) {
    id
  }
}
`

export const UPDATE_OFFERPRICE = gql`
mutation UpdateOfferPrcie($where: OfferPriceWhereInputOne!, $data: OfferPriceInput) {
  updateOfferPrcie(where: $where, data: $data) {
    id
  }
}
`
export const SALE_OFFER_PRICE = gql`
mutation SaleOfferPrice($where: OfferPriceGroupWhereInputOne!, $data: OfferPriceGroupInput) {
  saleOfferPrice(where: $where, data: $data) {
    id
  }
}
`